// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { UserSettingsType } from "../types";
import { updateUserSettings } from "../api";

export const useUpdateUserSettings = () => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();

  return useMutation({
    mutationFn: async (newSettingsData: UserSettingsType) => {
      try {
        const token = await getToken();
        return updateUserSettings(token, newSettingsData);
      } catch (error) {
        throw error;
      }
    },
    // Refetch user settings after a save either way, so a failed save puts
    // back anything that was updated ahead of it
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["user-settings"] });
    },
  });
};
